
import { mapActions, mapState } from "vuex";
import CreateEditAddonDialog from "../dialogs/create-edit-addon-dialog.vue";
import AddonItemActionTile from "./addon-item-action-tile.vue";
import AddonItemRowWithSwitch from "./addon-item-row-with-switch.vue";
export default {
  components: {
    AddonItemRowWithSwitch,
    CreateEditAddonDialog,
    AddonItemActionTile
  },
  data() {
    return {
      panel: null,
      showCreateAddonDialog: false
    };
  },
  beforeMount() {
    this.getAddons();
  },
  computed: {
    ...mapState("menu", ["addons"])
  },
  methods: {
    ...mapActions("menu", ["getAddons"])
  }
};
